import React, {Component} from 'react'
import PropTypes from 'prop-types'
import IdeaOwner from '../components/IdeaOwner'
import './css/CompactListItem.css'
import {Label, Col} from 'react-bootstrap'
import RecommendationLabel from '../components/RecommendationLabel'

let ideaRowStyle = {
    backgroundColor: '#ffffff',
    color: '#000000',
    height: 55+'px',
}

class CompactListItem extends Component {
    render() {
        if(!this.props.item)
            return null
        var name = this.props.item.ownerName ? this.props.item.ownerName : this.props.item.owner
        const tags = this.props.item.tags ? this.props.item.tags : []
        var url = this.props.item.ownerPhotoURL ? this.props.item.ownerPhotoURL : ''
        if (this.props.item.hasOwnProperty('responsible')){
            url = this.props.item.responsible.photoURL
            name = this.props.item.responsible.fullName
        }
        
        /* let totalChars = 0
        let shouldTrunc = -1
        let tagLimit = 0

        for(let i = 0; i < tags.length; i++){
            totalChars = totalChars + tags[i].length
            if (totalChars > 50){
                shouldTrunc = 0
                tagLimit = i
            }
            else if (shouldTrunc === -1){
                tagLimit = i
            }
        }

        if (this.props.item.name !== undefined){
            if (this.props.item.name.length > 50 && totalChars > 50){
                tagLimit = 1
            }
        }

        console.log('idea:', this.props.item.name, 'limit:', tagLimit, 'totalChars.length', totalChars) */

        return (

            <div className='row idea' style={ideaRowStyle}>
                <div>
                    <div>
                        <div className='divStyleTitle'>
                            <h4 className='compact-title'>
                            {this.props.item.name}
                            </h4>
                        </div>
                        <div className='divStyleProfile'>
                            {this.props.showFields.includes('owner') &&
                                <div className='compactListProfile'>
                                    <IdeaOwner
                                        ownerName={name}
                                        ownerPhotoURL={url}
                                    />
                                </div>
                            }    
                        </div>
                        <div className='divStyleTag'>
                            <Col smHidden xsHidden>
                              
                                    <div>
                                    {this.props.showFields.includes('rec') &&
                                        <RecommendationLabel 
                                            effortRating={this.props.item.effortRating} 
                                            impactRating={this.props.item.impactRating}
                                        />
                                    }
                                    {this.props.showFields.includes('tags') &&
                                        <div style={{display: 'inline-block'}}>
                                            {tags.map((tag, index) =>
                                            <div key={index+1} style={{display: 'inline-block'}}>
                                                <span className='tagSize' key={index}><Label bsStyle='primary'>{tag}</Label></span>
                                            </div>,
                                            )}
                                        </div>
                                    }
                                    </div>
                            </Col>
                        </div>
                    </div>
                </div> 
            </div>
                           
            


        )
    }
}
CompactListItem.propTypes = {
    item: PropTypes.object.isRequired,
    showFields: PropTypes.string.isRequired,
}

export default CompactListItem



// WEBPACK FOOTER //
// ./src/components/CompactListItem.js